export const FIELD_LABEL_TRANSLATIONS = {
    Email: 'メール',
    'First Name': '名',
    'Last Name': '姓',
    Phone: '電話番号',
    Mobile: '電話番号',
    Address: '住所',
    'Special Requirements': '特別な要望',
    // add more as needed
};